module.exports = __webpack_public_path__ + "static/media/switch-stack1.e32224f6.png";